<template>
  <form @submit.prevent="handleSubmit" class="form-group" ref="formRef">
    <p>Êtes-vous sûr de vouloir rembourser ce ticket ?</p>

    <div v-if="ticket" class="info-box">
      <p><strong>UUID:</strong> {{ ticket.uuid }}</p>
      <p><strong>Utilisateur:</strong> {{ ticket.user?.phone || 'N/A' }}</p>
      <p><strong>Trajet:</strong> {{ ticket.trip?.addressToStart?.city?.name }} → {{
        ticket.trip?.addressToEnd?.city?.name }}, le {{ new
        Date(ticket.trip?.timeToStart).toLocaleString() }}</p>
      <p><strong>Montant:</strong> {{ ticket.trip?.price }} FCFA</p>
      <p><strong>Date d'achat:</strong> {{ new Date(ticket.createdAt).toLocaleString() }}</p>
    </div>
      <label for="refundReason">Raison du remboursement *</label>
      <textarea
        id="refundReason"
        v-model="localData.reason"
        rows="3"
        placeholder="Expliquez la raison du remboursement..."
        required
      ></textarea>
    <div v-if="error" class="error-message">{{ error }}</div>
  </form>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  formData: { type: Object, default: () => ({ reason: '' }) },
  ticket: { type: Object, required: true }
})

const emit = defineEmits(['submit', 'cancel'])

const formRef = ref(null)
const error = ref('')

const localData = ref({
  reason: props.formData?.reason || ''
})

watch(() => props.formData, (newFormData) => {
  if (newFormData) {
    localData.value = {
      reason: newFormData.reason || ''
    }
  }
}, { deep: true })

const handleSubmit = () => {
  error.value = ''

  if (!formRef.value?.checkValidity()) {
    formRef.value?.reportValidity()
    return
  }

  emit('submit', { ...localData.value })
}

defineExpose({ handleSubmit })
</script>
